export default __webpack_public_path__ + "static/media/SWT0120.34I-27099_-16406_0.659fd9d1.jpg";